import { Hotel } from "typings/microserviceModels/hotels-flex-module";
import * as React from "react";
import { LocalizedText } from "bernie-l10n";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";
import { HotelNameRatingAndAddress } from "./HotelNameRatingAndAddress";
import { UitkPriceLockup } from "uitk-react-price-lockup";
import { NearestLocationContent } from "./NearestLocation/NearestLocationContent";
import { useLocalization } from "@shared-ui/localization-context";
import { validPrice } from "components/flexComponents/Hotels/utils/isValidPrice";
import { DATE_FORMAT } from "components/flexComponents/Hotels/utils/constants";

/**
 * CardContent which contains the overall ratings, pricing, value proposition
 * and guest amount (hard coded)
 */
export const CardContentReviewsPriceProposition = ({
  hotel,
  locale,
  context,
  isMobile,
  isViewCarousel,
  showCheckPrices,
  showGetPriceIfNoPrice,
  showDistance,
  showAddress,
  shouldUseImperialDistanceUnits,
  addressDistanceView,
}: {
  hotel: Hotel;
  locale: string;
  context: ExtendedContextStore;
  isMobile?: boolean;
  isViewCarousel?: boolean;
  showCheckPrices?: boolean;
  showGetPriceIfNoPrice?: boolean;
  showDistance?: boolean;
  showAddress?: boolean;
  shouldUseImperialDistanceUnits?: boolean;
  addressDistanceView?: string;
}) => {
  const { formattedPrice } = hotel;
  const { formatText, formatDateString } = useLocalization();
  const checkInDateFormatted = formatDateString(hotel.isoCheckIn, { skeleton: DATE_FORMAT });
  const checkOutDateFormatted = formatDateString(hotel.isoCheckOut, { skeleton: DATE_FORMAT });
  const { isValidPrice, showGetRates } = validPrice(hotel, isMobile, showCheckPrices, showGetPriceIfNoPrice);

  return (
    <>
      {isViewCarousel ? (
        <>
          <div className="uitk-grid">
            <div className="uitk-cell all-cell-fill">
              <div className="truncate uitk-type-heading-500 uitk-type-bold">{hotel.hotelName}</div>
            </div>
          </div>

          <div className="uitk-grid all-x-gutter-two">
            <div className="uitk-cell all-cell-fill">
              <HotelNameRatingAndAddress
                hotel={hotel}
                locale={locale}
                isViewCarousel={isViewCarousel}
                showAddress={showAddress}
                showDistance={showDistance}
                locationName={context.searchContext.location.name}
                shouldUseImperialDistanceUnits={shouldUseImperialDistanceUnits}
                addressDistanceView={addressDistanceView}
              />
            </div>
            {isValidPrice && (
              <UitkPriceLockup
                className="uitk-cell all-cell-shrink"
                lockupPrice={formattedPrice}
                priceCaptionFirst={formatText("hotels.price.perNight")}
                priceCaptionSecond={formatText("hotels.whenBooking", checkInDateFormatted, checkOutDateFormatted)}
              />
            )}
            {showGetRates && (
              <div className="uitk-cell all-cell-shrink uitk-type-right">
                <div className="uitk-type-600 hotelPricing">
                  <b>
                    <LocalizedText message="hotels.price.getRates" />
                  </b>
                </div>
              </div>
            )}
            <NearestLocationContent
              model={hotel.directDistance}
              shouldUseImperialDistanceUnits={shouldUseImperialDistanceUnits}
            />
          </div>
        </>
      ) : (
        <div className="uitk-grid all-x-gutter-two">
          <div className="uitk-cell all-cell-fill">
            <HotelNameRatingAndAddress
              hotel={hotel}
              locale={locale}
              isViewCarousel={isViewCarousel}
              showAddress={showAddress}
              showDistance={showDistance}
              locationName={context.searchContext.location?.name}
              shouldUseImperialDistanceUnits={shouldUseImperialDistanceUnits}
              addressDistanceView={addressDistanceView}
            />
          </div>
          {isValidPrice && (
            <UitkPriceLockup
              className="uitk-cell all-cell-shrink"
              lockupPrice={formattedPrice}
              priceCaptionFirst={formatText("hotels.price.perNight")}
              priceCaptionSecond={formatText("hotels.whenBooking", checkInDateFormatted, checkOutDateFormatted)}
            />
          )}
          {showGetRates && (
            <div className="uitk-cell all-cell-shrink uitk-type-right">
              <div className="uitk-type-600 hotelPricing">
                <b>
                  <LocalizedText message="hotels.price.getRates" />
                </b>
              </div>
            </div>
          )}
          <NearestLocationContent
            model={hotel.directDistance}
            shouldUseImperialDistanceUnits={shouldUseImperialDistanceUnits}
          />
        </div>
      )}
    </>
  );
};
